define(
    'viewmodels/secured/uploads/tabs/documents/documents',[
        "viewmodels/ViewModelNotification",
        "viewmodels/secured/uploads/context",
        "providers/dataprovider",
        "i19n!i19n/strings"
    ],
    function (ViewModelNotification, ctx, dataProvider, i19n) {
        var grid = null;
        var $grid = null;

        var vm = new ViewModelNotification(
        {
            i19n: i19n,
            folderShareId: ko.observable()
        });

        vm.activate = function () {
            vm.folderShareId(sessionStorage.getItem("upload-request-id"));

            if (grid) {
                grid.dataSource.read();
            }
        };
        vm.attached = function () {
            $grid = $("#upload-request-details-document-grid");

            buildKendoGrid();
            
            function buildKendoGrid() {
                var columns = [
                    { field: "documentId", hidden: true },
                    { field: "title", title: i19n.to.title},
                    { field: "extension", title: i19n.to.ext, width: 50 },
                    { field: "docId", title: i19n.to.docid, width: 100 },
                    { field: "uploadedBy", title: i19n.to.uploadedby, width: 210 },
                    { field: "uploadDate", title: i19n.to.uploaddate, width: 160, format: "{0:g}" } //d MMM yyyy hh:mm tt
                ];

                grid = $grid.kendoGrid({
                    excel: {
                        allPages: true,
                        fileName: "upload-request-document-details.xlsx"
                    },
                    dataBound: function () {
                        resizeGrid();
                    },
                    dataSource: getKendoGridDataSource(),
                    resizable: true,
                    sortable: true,
                    columns: columns,
                    scrollable: true
                }).data("kendoGrid");                
            }
            function getKendoGridDataSource() {
                var schema = {
                    model: {
                        id: "documentId",
                        fields: {
                            documentId: { type: "string" },
                            //title: { type: "string" },
                            //extension: { type: "string" },
                            //docId: { type: "string" },
                            uploadDate: { type: "date" }
                        }
                    }
                };

                return new kendo.data.DataSource({
                    transport: {
                        read: function (callbacks) {
                            ctx.loadForUploadRequestDetails(vm.folderShareId())
                            .done(function (data) {
                                callbacks.success(data.documents);

                                setTimeout(function () {
                                    resizeGrid();
                                }, 500);
                            })
                            .fail(function (e) {
                                console.error(e);
                            });
                        }
                    },
                    schema: schema,
                    pageSize: 999
                });

            }            

            $(window).on("resize", _.debounce(resizeGrid, 250));
        };
        
        vm.exportToExcel = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                grid.saveAsExcel();
                
                complete();
            }
        });

        return vm;

        function resizeGrid() {
            if (!$grid)
                return;

            var newGridHeight = $("#upload-request-details-content").outerHeight() - 355;

            $grid.height(newGridHeight);

            grid.resize();
        }
    }
);
